module.exports = __webpack_public_path__ + "static/img/son13_active.a30d11ef.png";